<div class="form-group-custom">
  <label for="inputCruiseDate" class="input-group-zeus__label">Data</label>
  <div
    class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent"
    id="cruiseDate-select"
  >
    <ng-select
      [items]="
        (cruisePrefetch$ | async)?.departures
          | adaptCruiseDate
          | orderBy : '+date'
      "
      [loading]="!(cruisePrefetch$ | async)"
      [searchable]="(isMobile$ | async) ? false : true"
      [dropdownPosition]="
        (isMobile$ | async) && (isWidget$ | async) ? 'bottom' : 'auto'
      "
      placeholder="Seleziona la data"
      bindValue="dateString"
      
      (change)="selectDate($event)"
      id="inputCruiseDate"
      class="form-control-custom"
      [(ngModel)]="selectedDateInner"
    >
    </ng-select>
    <div
      class="input-group-custom__prepend input-group-custom__prepend--transparent"
    >
      <span
        class="input-group-custom__icon input-group-custom__icon--transparent"
        id="basic-addon3"
        ><i class="icon-date"></i
      ></span>
    </div>
  </div>
</div>
